module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szamlacsoport1.8c1886ed.jpg";